import getApolloClient from './client';
export { default as QueryComponent } from './util/QueryComponent';
export { default as getStoreApolloClient } from './store-client';

export default getApolloClient;
